import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import defaultLang, {en_US, fa_IR} from '../../constants/locales';
import jMoment from 'moment-jalaali';

const resources = {
  [en_US]: {
    translation: require('../../locales/en-US'),
  },
  [fa_IR]: {
    translation: require('../../locales/fa-IR'),
  },
};

jMoment.loadPersian({
  dialect: 'persian-modern',
  usePersianDigits: false,
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLang,

    keySeparator: false,
    nsSeparator: false,

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
